import script from "./faq.vue?vue&type=script&setup=true&lang=ts"
export * from "./faq.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./faq.vue?vue&type=style&index=0&id=06948ab2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "D:\\Projects\\scrap\\scrapped.net\\user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__